import useLazyByProject from './useLazyByProject';
import { getActivity } from '../services/CollabService';

const DAYS = 30;
const LIMIT = 100;

/**
 * The activity of each project of a workspace over the last 30 days (the same feed as a project's History › Activity,
 * services/CollabService.js getActivity), three projects at a time. Returns `{ entries, reload }` as
 * `useLazyByProject`; a value is the project's events, newest first.
 */
export default function useWorkspaceActivity(projectIds, { enabled = true } = {}) {
  return useLazyByProject(projectIds, async(projectId) => {
    const since = new Date(Date.now() - DAYS * 24 * 3600 * 1000).toISOString();
    const answer = await getActivity(projectId, { since, limit: LIMIT });
    return Array.isArray(answer?.events) ? answer.events : [];
  }, { enabled, concurrency: 3 });
}
